import React from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import { useSuspenseFragment } from 'react-relay-offline'
import { Route, Switch, useLocation } from 'react-router'

import type { DrawerProps } from '../../../../ui/components'
import { Drawer, DrawerCloseButton } from '../../../../ui/components'
import { PaymentMethodInfoStep } from './PaymentMethodInfoStep'
import type { PaymentsMethodsListDrawer_PaymentOptionConnection$key } from './__generated__/PaymentsMethodsListDrawer_PaymentOptionConnection.graphql'
import { PaymentsMethodsListContentStep } from './PaymentsMethodsListContentStep'

const paymentOptionConnectionFragment = graphql`
  fragment PaymentsMethodsListDrawer_PaymentOptionConnection on PaymentOptionConnection {
    ...PaymentsMethodsListContentStep_PaymentOptionConnection
    ...PaymentMethodInfoStep_PaymentOptionConnection
  }
`

export type PaymentsMethodsListDrawerProps = DrawerProps & {
  paymentOptionConnectionRef: PaymentsMethodsListDrawer_PaymentOptionConnection$key
}

export const PaymentsMethodsListDrawer = ({
  paymentOptionConnectionRef,
  ...props
}: PaymentsMethodsListDrawerProps) => {
  const { hash } = useLocation()

  const paymentOptionConnection = useSuspenseFragment(
    paymentOptionConnectionFragment,
    paymentOptionConnectionRef
  )

  const showPaymentsMethodsListStep = hash === '#/payments-methods-drawer'
  const showPaymentMethodInfoStep = !!hash.split('/')[2] // TODO: improve it

  return (
    <Drawer {...props}>
      <DrawerCloseButton />
      <Switch>
        <Route path="" />
      </Switch>
      {showPaymentsMethodsListStep && (
        <PaymentsMethodsListContentStep
          paymentOptionConnectionRef={paymentOptionConnection}
        />
      )}
      {showPaymentMethodInfoStep && (
        <PaymentMethodInfoStep
          paymentOptionConnectionRef={paymentOptionConnection}
        />
      )}
    </Drawer>
  )
}
